import { IRootReducer } from "../reducers";

export const getThemeMode = (state:IRootReducer) => state.preferences.themeMode; 